import { useRouter } from "next/router";

import NavBar from "../navbar/index";
import Footer from "../footer/index";

import cName from 'classnames';
import styles from "./styles.module.scss";

export default ({ children }: { children: JSX.Element }) => {
  const router = useRouter()

  const headerBlackList = [];
  const footerBlackList = [];

  return (
    <div className={cName(styles.layout, router.locale === 'en' ? styles.en : 'cn')}>
      {
        !headerBlackList.includes(router.pathname) && <NavBar />
      }
      <main className={styles.main}>{children}</main>
      {
        !footerBlackList.includes(router.pathname) && <Footer />
      }
    </div>
  );
};
